import { render, staticRenderFns } from "./AppInfoDetailList.vue?vue&type=template&id=9f19b04e&"
import script from "./AppInfoDetailList.vue?vue&type=script&lang=js&"
export * from "./AppInfoDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports